import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ResolveData } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Store } from '@ngrx/store';
import { BehaviorSubject, combineLatest, of, Subscription, switchMap } from 'rxjs';
import { DoctorEntity } from '../dave-data-module/entities/mdqx/doctor/doctor.entity';
import { DoctorResolver } from '../dave-data-module/guards/mdqx/doctor/doctor.resolver';
import { State } from '../dave-data-module/State';
import { DOCTOR_KEY } from '../dave-data-module/State/reducers/mdqx/doctor/doctor.reducer';
import { getDoctorsById } from '../dave-data-module/State/selectors/mdqx/selectors';
import { DOCTOR_CATALOG_FEATURE_KEY } from '../dave-data-module/State/reducers/mdqx/doctor/doctor-catalog.reducer';
import { DoctorCatalogResolver } from '../dave-data-module/guards/mdqx/doctor/doctor-catalog.resolver';
import { QUALIFICATION_FEATURE_KEY } from '../dave-data-module/State/reducers/mdqx/doctor/qualification.reducer';
import { QualificationResolver } from '../dave-data-module/guards/mdqx/doctor/qualification.resolver';
import { getPersonTypeById } from '../dave-data-module/State/selectors/personType.selectors';
import { getQualificationById } from '../dave-data-module/State/selectors/mdqx/doctor/qualification.selector';
import { tap } from 'rxjs/operators';
import { getDoctorCatalogById } from '../dave-data-module/State/selectors/mdqx/doctor/doctor-catalog.selector';

@Component({
    selector: 'app-doctor-list-entry',
    standalone: true,
    imports: [CommonModule, FontAwesomeModule],
    templateUrl: './doctor-list-entry.component.html',
    styleUrls: ['./doctor-list-entry.component.scss'],
})
export class DoctorListEntryComponent {
    public static readonly RequiredResolvers: ResolveData = {
        [DOCTOR_KEY]: DoctorResolver,
         [DOCTOR_CATALOG_FEATURE_KEY]: DoctorCatalogResolver, // Facharztbez
        [QUALIFICATION_FEATURE_KEY]: QualificationResolver,
    };
    doctorId$ = new BehaviorSubject<number | null>(null);
    @Input() set DoctorId(id: number) {
        if (this.doctorId$.value !== id) {
            this.doctorId$.next(id);
        }
    }
    protected doctor$ = this.doctorId$.pipe(switchMap((id) => this.store.select(getDoctorsById({ id }))));

    protected qualifications$ = this.doctor$.pipe(
        switchMap((doctor) => {
            if (!doctor?.QualificationIds || doctor.QualificationIds.length === 0) {
                return of(null);
            }

            const qualificationObservables = doctor.QualificationIds.map((qualificationId) => {
                return this.store.select(getQualificationById({ id: qualificationId }));
            });

            return combineLatest(qualificationObservables);
        })
    );

    protected doctorCatalogs$ = this.doctor$.pipe(
        switchMap((doctor) => {
            if (!doctor?.DoctorCatalogIds || doctor.DoctorCatalogIds.length === 0) {
                return of(null);
            }

            const DoctorCatalogObservables = doctor.DoctorCatalogIds.map((doctorCatalogId) => {
                return this.store.select(getDoctorCatalogById({ id: doctorCatalogId }));
            });

            return combineLatest(DoctorCatalogObservables);
        })
    );
    constructor(protected store: Store<State>) {}
}
